// src/components/QuoteFormSection.jsx
import React, { useRef, useState, useEffect } from 'react'; // 1. Importa los hooks necesarios
import emailjs from '@emailjs/browser'; // 2. Importa emailjs

function QuoteFormSection() {
  // 3. Crea una referencia para tu formulario
  const form = useRef();

  // 4. Estado para manejar la notificación (éxito o error)
  const [notification, setNotification] = useState(null);

  // 5. Efecto para ocultar la notificación automáticamente después de 5 segundos
  useEffect(() => {
    if (notification) {
      const timer = setTimeout(() => {
        setNotification(null);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [notification]);

  const sendEmail = (e) => {
    e.preventDefault();
    console.log("Intentando enviar formulario de cotización...");

    // 6. Envía el email usando emailjs con el NUEVO TEMPLATE ID
    emailjs.sendForm('service_roazv1r', 'template_7nufwnd', form.current, '23bh4vJCRzng0cTTl')
      .then((result) => {
          console.log('SUCCESS!', result.text);
          // 7. Muestra la notificación de éxito
          setNotification({ type: 'success', text: '¡Solicitud de cotización enviada con éxito!' });
          form.current.reset(); // Limpia el formulario
      }, (error) => {
          console.log('FAILED...', error.text);
          // 8. Muestra la notificación de error
          setNotification({ type: 'error', text: 'Hubo un error al enviar la solicitud. Inténtalo de nuevo.' });
      });
  };

  return (
    <div className="container-fluid overflow-hidden my-5 px-lg-0">
      <div className="container quote px-lg-0">
        <div className="row g-0 mx-lg-0">
          <div className="col-lg-6 quote-text" data-parallax="scroll" data-image-src="/img/carousel-1.jpg">
            <div className="h-100 px-4 px-sm-5 ps-lg-0 wow fadeIn" data-wow-delay="0.1s">
              <h1 className="text-white mb-4">¿Qué podemos hacer por ti? </h1>
              <p className="text-light mb-5">Ya seas una empresa o un particular, si tienes alguna pregunta, comentario o quieres explorar un proyecto, déjanos un mensaje. Respondedremos a la mayor brevedad.</p>
            </div>
          </div>
          <div className="col-lg-6 quote-form" data-parallax="scroll" data-image-src="/img/carousel-2.jpg">
            <div className="h-100 px-4 px-sm-5 pe-lg-0 wow fadeIn" data-wow-delay="0.5s">
              <div className="bg-white p-4 p-sm-5">
                {/* 9. Renderiza la notificación si existe */}
                {notification && (
                  <div className={`alert ${notification.type === 'success' ? 'alert-success' : 'alert-danger'} alert-dismissible fade show mb-4`} role="alert">
                    {notification.text}
                    <button type="button" className="btn-close" onClick={() => setNotification(null)}></button>
                  </div>
                )}

                {/* 10. Conecta la referencia y la función al formulario */}
                <form ref={form} onSubmit={sendEmail}>
                  <div className="row g-3">
                    <div className="col-sm-6">
                      <div className="form-floating">
                        <input type="text" className="form-control" id="gname" name="nombre" placeholder="Tu Nombre" required />
                        <label htmlFor="gname">Nombre</label>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-floating">
                        <input type="email" className="form-control" id="gmail" name="email" placeholder="Tu Email" required />
                        <label htmlFor="gmail">Email</label>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-floating">
                        <input type="tel" className="form-control" id="cname" name="telefono" placeholder="Tu Teléfono" />
                        <label htmlFor="cname">Telefono</label>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-floating">
                        <input type="text" className="form-control" id="cage" name="servicio" placeholder="Tipo de Servicio" />
                        <label htmlFor="cage">Tipo de Servicio</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-floating">
                        <textarea className="form-control" placeholder="Déjanos tu mensaje" id="message" name="mensaje" style={{height: '80px'}} required></textarea>
                        <label htmlFor="message">Mensaje</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <button className="btn btn-primary py-3 px-5" type="submit">Enviar</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QuoteFormSection;